import React from 'react'

const loader = () => {
  return (
    <div className='contain'>
        <img className='loader' src="/Images/AV.gif"/>
    </div>
  )
}

export default loader